<div class="list-container">
    <div class="list-wrapper">
        <ul class="list">
            <li class="list-item" *ngFor="let firstLevelItem of list; let i = index">
                <span
                    class="list-item"
                    attr.data-e2e-hook="{{ e2eHook }}-list-first-level-item-{{ i }}"
                    (click)="onAnyLevelItemSelected(firstLevelItem)"
                    [ngClass]="{
                        'is-active': firstLevelItem.isActive,
                        'is-disabled': disabled || (firstLevelItem.isDisabled && !firstLevelItem.isActive)
                    }"
                >
                    {{ firstLevelItem.text }}
                </span>

                <div
                    *ngIf="firstLevelItem.subList && firstLevelItem.subList.length > 0"
                    class="nested-list"
                    [hidden]="!firstLevelItem.showSubList"
                >
                    <ul class="list">
                        <li class="list-item" *ngFor="let secondLevelItem of firstLevelItem.subList; let j = index">
                            <span
                                class="list-item"
                                attr.data-e2e-hook="{{ e2eHook }}-list-second-level-item-{{ j }}"
                                (click)="onAnyLevelItemSelected(firstLevelItem, secondLevelItem)"
                                [ngClass]="{
                                    'is-active': secondLevelItem.isActive,
                                    'is-disabled': disabled || (secondLevelItem.isDisabled && !secondLevelItem.isActive)
                                }"
                            >
                                {{ secondLevelItem.text }}
                            </span>

                            <div
                                *ngIf="secondLevelItem.subList && secondLevelItem.subList.length > 0"
                                class="nested-list"
                                [hidden]="!secondLevelItem.showSubList"
                            >
                                <ul class="list">
                                    <li
                                        class="list-item"
                                        *ngFor="let thirdLevelItem of secondLevelItem.subList; let k = index"
                                    >
                                        <span
                                            class="list-item"
                                            attr.data-e2e-hook="{{ e2eHook }}-list-third-level-item-{{ k }}"
                                            (click)="
                                                onAnyLevelItemSelected(firstLevelItem, secondLevelItem, thirdLevelItem)
                                            "
                                            [ngClass]="{
                                                'is-active': thirdLevelItem.isActive,
                                                'is-disabled':
                                                    disabled || (thirdLevelItem.isDisabled && !thirdLevelItem.isActive)
                                            }"
                                        >
                                            {{ thirdLevelItem.text }}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
</div>
